import * as React from 'react';
const GreenTickFilledIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 16}
    height={props.height || 16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <circle cx={8} cy={8} r={8} fill="#14B195" />
    <path
      fill="#fff"
      d="M11.001 5.25a.748.748 0 0 0-.53.219L7 8.938l-1.718-1.72A.751.751 0 1 0 4.22 8.282l2.25 2.25a.75.75 0 0 0 1.063 0l4-4A.75.75 0 0 0 11 5.25Z"
    />
  </svg>
);
export default GreenTickFilledIcon;
